import React, { FC, memo } from 'react';
import { useField } from 'formik';

import usePrefix from 'utils/usePrefix';
import TextAreaComponent from 'components/TextAreaComponent';
import FormDescription from 'components/ResqlExpert/FormDescription';
import { FormSectionStyled, TabBodyContentStyled } from 'components/ResqlExpert/SubmissionForm/styles';

const Results: FC = () => {
  const t = usePrefix('ResqlExpert');
  const [positiveField, , positiveHelpers] = useField<string>('positive_outcomes');
  const [negativeField, , negativeHelpers] = useField<string>('negative_outcomes');
  const positive = positiveField.value ?? '';
  const negative = negativeField.value ?? '';

  return (
    <TabBodyContentStyled>
      <FormSectionStyled>
        <FormDescription title={t('tab_results')}>
          <p>{t('tab_results_hint')}</p>
        </FormDescription>
        <TextAreaComponent
          id="positive_outcomes"
          label={t('tab_results_positive')}
          placeholder={t('tab_results_positive')}
          text={positive}
          setText={(v) => positiveHelpers.setValue(v)}
        />
        <TextAreaComponent
          id="negative_outcomes"
          label={t('tab_results_negative')}
          placeholder={t('tab_results_negative')}
          text={negative}
          setText={(v) => negativeHelpers.setValue(v)}
        />
      </FormSectionStyled>
    </TabBodyContentStyled>
  );
};

export default memo(Results);
